module.exports = "<sx-listado-desplegable \r\n[fuente]=\"grupos\"\r\n[tipo]=\"title | translate\">\r\n</sx-listado-desplegable>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/channel/configurar.channel.component.html
// module id = ../../../../../src/app/private/configuracion/channel/configurar.channel.component.html
// module chunks = main